(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-reels')) {
    class UgcReels extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ugc__track');
        this.group = this.querySelector('.ugc__group');
        if (!this.track || !this.group || !this.group.children.length) return;

        this.loop = this.dataset.loop === 'true';
        this.auto = this.dataset.auto === 'true';
        this.videoAuto = this.dataset.videoAutoplay === 'true';
        this.pauseHover = this.dataset.pauseHover === 'true';
        this.speed = Number(this.dataset.speed) || 30;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.offset = 0;
        this.vel = 0;
        this.period = 0;
        this.hover = false;
        this.focused = false;
        this.dragging = false;
        this.down = false;
        this.moved = false;
        this.raf = 0;
        this.last = 0;

        this.classList.toggle('is-loop', this.loop);
        this.tick = this.tick.bind(this);

        this.setupVideos();
        this.bind();
        this.build();

        this.ro = new ResizeObserver(() => {
          clearTimeout(this.rt);
          this.rt = setTimeout(() => this.build(), 150);
        });
        this.ro.observe(this);

        this.vis = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) this.start();
          else this.stop();
        });
        this.vis.observe(this);
      }

      disconnectedCallback() {
        this.stop();
        clearTimeout(this.rt);
        if (this.ro) this.ro.disconnect();
        if (this.vis) this.vis.disconnect();
        if (this.vio) this.vio.disconnect();
      }

      /* ---------- build clones so the loop never shows empty space ---------- */
      build() {
        this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());

        if (this.loop) {
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const groupWidth = this.group.getBoundingClientRect().width;
          const viewWidth = this.clientWidth;
          if (groupWidth && viewWidth) {
            this.period = groupWidth + gap;
            const copies = Math.ceil(viewWidth / this.period) + 1;
            for (let i = 0; i < copies; i++) {
              const clone = this.group.cloneNode(true);
              clone.setAttribute('data-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
              clone.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
              this.track.appendChild(clone);
            }
            this.wrap();
            this.render();
          }
        }
        this.observeVideos();
      }

      wrap() {
        if (!this.period) return;
        this.offset = ((this.offset % this.period) + this.period) % this.period;
      }

      render() {
        this.track.style.transform = 'translate3d(' + -this.offset + 'px,0,0)';
      }

      /* ---------- animation loop (only runs while section is on screen) ---------- */
      start() {
        if (!this.loop || this.raf) return;
        this.last = 0;
        this.raf = requestAnimationFrame(this.tick);
      }

      stop() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      tick(t) {
        const dt = Math.min((t - (this.last || t)) / 1000, 0.05);
        this.last = t;

        if (this.period && !this.dragging) {
          let move = this.vel * dt;
          this.vel *= Math.exp(-4 * dt);
          if (Math.abs(this.vel) < 1) this.vel = 0;

          const paused = (this.pauseHover && this.hover) || this.focused;
          if (this.auto && !paused && !this.reduce.matches) move += this.speed * dt;

          if (move) {
            this.offset += move;
            this.wrap();
            this.render();
          }
        }
        this.raf = requestAnimationFrame(this.tick);
      }

      /* ---------- drag / swipe / wheel ---------- */
      bind() {
        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hover = true; });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.hover = false; });
        this.addEventListener('focusin', () => { this.focused = true; });
        this.addEventListener('focusout', (e) => { this.focused = this.contains(e.relatedTarget); });
        this.addEventListener('dragstart', (e) => e.preventDefault());

        // Block the link click that would otherwise fire after a drag
        this.addEventListener('click', (e) => {
          if (this.moved) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        // Focus can scroll the hidden overflow container: fold it back into the loop
        this.addEventListener('scroll', () => {
          if (this.loop && this.scrollLeft) {
            this.offset += this.scrollLeft;
            this.scrollLeft = 0;
            this.wrap();
            this.render();
          }
        });

        this.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (!this.loop && e.pointerType !== 'mouse') return; // native scrolling handles touch
          this.down = true;
          this.moved = false;
          this.pid = e.pointerId;
          this.sx = e.clientX;
          this.lx = e.clientX;
          this.lt = e.timeStamp;
          this.vel = 0;
          this.base = this.loop ? this.offset : this.scrollLeft;
        });

        this.addEventListener('pointermove', (e) => {
          if (!this.down || e.pointerId !== this.pid) return;
          const dx = e.clientX - this.sx;
          if (!this.moved) {
            if (Math.abs(dx) < 6) return;
            this.moved = true;
            this.dragging = true;
            this.classList.add('is-dragging');
            try { this.setPointerCapture(e.pointerId); } catch (err) {}
          }
          if (this.loop) {
            const dtm = (e.timeStamp - this.lt) / 1000;
            if (dtm > 0) {
              const inst = (this.lx - e.clientX) / dtm;
              this.vel = Math.max(-2500, Math.min(2500, this.vel * 0.6 + inst * 0.4));
            }
            this.offset = this.base - dx;
            this.wrap();
            this.render();
          } else {
            this.scrollLeft = this.base - dx;
          }
          this.lx = e.clientX;
          this.lt = e.timeStamp;
        });

        const end = (e) => {
          if (!this.down || e.pointerId !== this.pid) return;
          this.down = false;
          this.dragging = false;
          this.classList.remove('is-dragging');
          if (e.timeStamp - this.lt > 80) this.vel = 0;
          try { this.releasePointerCapture(e.pointerId); } catch (err) {}
          setTimeout(() => { this.moved = false; }, 0);
        };
        this.addEventListener('pointerup', end);
        this.addEventListener('pointercancel', end);

        // Horizontal trackpad / shift+wheel in loop mode
        this.addEventListener('wheel', (e) => {
          if (!this.loop) return;
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
            e.preventDefault();
            this.offset += e.deltaX;
            this.wrap();
            this.render();
          }
        }, { passive: false });
      }

      /* ---------- lazy video loading / playback ---------- */
      setupVideos() {
        const canAuto = () => this.videoAuto && !this.reduce.matches;

        this.vio = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const v = entry.target;
            if (entry.isIntersecting) {
              if (canAuto()) { this.load(v); this.play(v); }
            } else {
              v.pause();
            }
          });
        }, { rootMargin: '0px 150px' });

        // Autoplay off: play on hover (desktop only)
        if (!this.videoAuto) {
          this.addEventListener('pointerover', (e) => {
            if (e.pointerType !== 'mouse' || this.reduce.matches) return;
            const card = e.target.closest('.ugc__card');
            if (!card || card.contains(e.relatedTarget)) return;
            const v = card.querySelector('video');
            if (v) { this.load(v); this.play(v); }
          });
          this.addEventListener('pointerout', (e) => {
            const card = e.target.closest('.ugc__card');
            if (!card || card.contains(e.relatedTarget)) return;
            const v = card.querySelector('video');
            if (v) v.pause();
          });
        }
      }

      observeVideos() {
        this.vio.disconnect();
        this.querySelectorAll('video').forEach((v) => {
          if (!v._ugcBound) {
            v._ugcBound = true;
            v.addEventListener('playing', () => v.closest('.ugc__card').classList.add('is-playing'));
            v.addEventListener('pause', () => v.closest('.ugc__card').classList.remove('is-playing'));
          }
          this.vio.observe(v);
        });
      }

      load(v) {
        if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
      }

      play(v) {
        v.muted = true;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }
    }
    customElements.define('ugc-reels', UgcReels);
  }

  } catch(e) { console.error(e); }
})();
})();
